// home.js
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { TabContent, TabPane, Nav, NavItem, NavLink, Col } from 'reactstrap';
import classnames from 'classnames';

import '../home/Home.css';
import DashBoardSiaSus from '../Dashboards/SiaSus';
import DashBoardSihSus from '../Dashboards/SihSus';
import Loading from '../Dashboards/Common/Loading';
import DashBoardSamu from '../Dashboards/Samu';

const Indicators = ({
    showNav,
    activeTab,
    setActiveTab,
    indicatorsTabs,
    isLoading
}) => {
    const sessionSelector = useSelector((state) => {
        return state.core.session;
    });

    const { has_siasus_dashboard, has_sihsus_dashboard, has_samu_dashboard } = sessionSelector;

    useEffect(() => {
        if (
            indicatorsTabs &&
            indicatorsTabs.length > 0 &&
            !indicatorsTabs.map((item) => item.value).includes(activeTab)
        ) {
            setActiveTab(indicatorsTabs[0].value);
        }
    }, [indicatorsTabs, activeTab]);

    if (isLoading && activeTab !== '-1' && activeTab !== '-2') {
        return <Loading />;
    }

    return (
        <div
            className="mt-3 mr-2"
            style={{
                marginLeft: '50px'
            }}
        >
            {showNav && (
                <Nav tabs>
                    {indicatorsTabs &&
                        indicatorsTabs.map((item, index) => (
                            <NavItem>
                                <NavLink
                                    style={{ cursor: 'pointer' }}
                                    className={classnames({
                                        active: activeTab === item.value
                                    })}
                                    onClick={() => {
                                        setActiveTab(item.value);
                                    }}
                                    styles={{
                                      color: '#000',
                                    }}
                                >
                                    {item.title}
                                </NavLink>
                            </NavItem>
                        ))}
                </Nav>
            )}

            <TabContent activeTab={activeTab} className="bg-white">
                {indicatorsTabs &&
                    indicatorsTabs
                        .filter((item) => item.indicator_link)
                        .map((item, index) => (
                            <TabPane tabId={item.value} key={index}>
                                <Col
                                    sm="12"
                                    style={{
                                        overflowY: 'hidden',
                                        maxHeight: '640px'
                                    }}
                                >
                                    <iframe
                                        src={item.indicator_link}
                                        title={`indicator-${index}`}
                                        style={{
                                            width: '100%',
                                            height: '700px',
                                            border: 'none'
                                        }}
                                        allow="fullscreen"
                                    ></iframe>
                                </Col>
                            </TabPane>
                        ))}

                {has_siasus_dashboard && (
                    <TabPane tabId={'-1'}>
                        <Col sm="12">
                            <DashBoardSiaSus />
                        </Col>
                    </TabPane>
                )}

                {has_sihsus_dashboard && (
                    <TabPane tabId={'-2'}>
                        <Col sm="12">
                            <DashBoardSihSus />
                        </Col>
                    </TabPane>
                )}

                {has_samu_dashboard && (
                    <TabPane tabId={'-3'}>
                        <Col sm="12">
                            <DashBoardSamu />
                        </Col>
                    </TabPane>
                )}
            </TabContent>
        </div>
    );
};

export default Indicators;
